import React, { HTMLAttributes } from 'react';
import { GenericTableRow } from 'src/components/PortalList/PortalList.styles';
import { ISignatureResponse } from 'src/models';
import SigneeAction from './PortalSigneeAction';
import {
  SigneeCell,
  SigneeCellLast,
  SigneeTitle,
} from './PortalSigneesList.styles';

interface ISigneeRow extends HTMLAttributes<HTMLTableRowElement> {
  companyRoles: string;
  fullName: string;
  actionDateTime?: ISignatureResponse['actionDateTime'];
  actionRole?: ISignatureResponse['actionRole'];
}

const SigneeRow = ({
  actionDateTime,
  actionRole,
  companyRoles,
  fullName,
  ...rest
}: ISigneeRow) => {
  return (
    <GenericTableRow role="row" {...rest} key={fullName}>
      <SigneeCell>
        <SigneeTitle title={fullName} subtitle={companyRoles} />
      </SigneeCell>
      <SigneeCellLast>
        {actionDateTime && actionRole ? (
          <SigneeAction
            actionRole={actionRole}
            actionDateTime={actionDateTime}
          />
        ) : null}
      </SigneeCellLast>
    </GenericTableRow>
  );
};

export default SigneeRow;
